/**
 * Safe error logging.
 *
 * Logging a raw AxiosError to the console dumps `config.headers` (including the
 * `Authorization: Bearer ...` header) and `config.data` (the request payload).
 * Use these helpers instead of `console.error(error)` for anything that may come
 * from an HTTP client.
 */

export interface SafeErrorInfo {
  name?: string;
  message?: string;
  code?: string;
  status?: number;
  method?: string;
  url?: string;
}

function stripQuery(url: unknown): string | undefined {
  return typeof url === "string" ? url.split(/[?#]/)[0] : undefined;
}

export function toSafeErrorInfo(error: unknown): SafeErrorInfo {
  if (!error || typeof error !== "object") {
    return { message: typeof error === "string" ? error : undefined };
  }
  const e = error as any;
  return {
    name: e.name,
    message: e.message,
    code: e.code,
    status: e.response?.status,
    method: typeof e.config?.method === "string" ? e.config.method.toUpperCase() : undefined,
    url: stripQuery(e.config?.url),
  };
}

export function logSafeError(context: string, error: unknown): void {
  console.error(context, toSafeErrorInfo(error));
}
